export default __webpack_public_path__ + "static/media/weightlosswithfamily_2@2x.591575dc.jpg";